import React from "react";
import CommonAuthHeader from "./CommonAuthHeader";
import RegisterStepTwo from "../auth/RegisterStepTwo";
import CommonHeader from "../CommonHeader";
import { isTMA } from "../constants";

const OptionsRegisterStepTwo = () => {
  const telegramAppSx = {
    backgroundColor: "white",
  };

  const webAppSx = {
    height: "100%",
  };
  return (
    <>
      <CommonHeader icon="backArrow" />
      <CommonAuthHeader
        showSpeedLogo={false}
        sx={isTMA() ? telegramAppSx : webAppSx}
      >
        <RegisterStepTwo isFromOptions />
      </CommonAuthHeader>
    </>
  );
};

export default OptionsRegisterStepTwo;
